<template>
	<div>
		<!-- Institute select  -->
		<div class="d-flex justify-content-between align-items-center">
			<div class="px-0 mb-3" v-if="checkUser">
				<v-select
					data-testId="institute-select"
					auto-select-first
					v-bind:items="institutes"
					v-model="currentIns"
					v-on:change="changeInstitute"
					item-text="name"
					item-value="id"
					:label="$t('instituteName')"
					color="green"
					item-color="green"
				>
				</v-select>
			</div>
			<v-spacer></v-spacer>
		</div>

		<!-- Search inputs -->
		<div class="search">
			<div class="search-inputs">
				<v-text-field
					data-testId="full-name-input"
					v-model="searchObj.fullName"
					:label="$t('tables.name')"
					color="green"
					clearable
					clear-icon="mdi-close-circle"
				></v-text-field>
				<v-text-field
					data-testId="email-input"
					v-model="searchObj.email"
					:label="$t('tables.email')"
					color="green"
					clearable
					clear-icon="mdi-close-circle"
				></v-text-field>
				<!-- <v-text-field
					data-testId="phone-number-input"
					v-model="searchObj.phoneNumber"
					label="Phone number"
					color="green"
					clearable
					clear-icon="mdi-close-circle"
				></v-text-field> -->
			</div>
			<div class="search-btn-group">
				<v-btn
					data-testId="search-btn"
					color="success"
					class="me-4"
					@click="searchForContact"
				>
					{{ $t("search") }}
				</v-btn>
				<v-btn data-testId="clear-btn" color="error" @click="clearSearch">
					{{ $t("clear") }}
				</v-btn>
			</div>
		</div>

		<!-- Contact us list tabular view -->
		<div class="mt-6">
			<h4>{{ $t("sideMenu.contactUsList") }}</h4>
			<v-data-table
				:headers="contactListHeaders"
				:items="contactList"
				item-key="id"
				class="elevation-1"
				:server-items-length="totalContacts"
				:items-per-page="tableOptions.itemsPerPage"
				:footer-props="tableFooterOptions"
				:options="tableOptions"
				@update:options="updateContactUsList"
				:no-data-text="`${$t('noResultsHere')}`"
			>
			</v-data-table>
		</div>
	</div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
// import moment from "moment-timezone";

export default {
	name: "ContactUsList",
	mixins: [GlobalMixin],
	data() {
		return {
			institutes: [],
			currentIns: 1,
			userObj: JSON.parse(localStorage.getItem("vuex")),

			contactList: [],
			totalContacts: null,

			searchObj: {
				fullName: "",
				email: "",
				// phoneNumber: "",
			},
			search: {},

			tableFooterOptions: {
				"items-per-page-options": [10, 20, 30, 40, 50, 100],
				"show-current-page": true,
				showFirstLastPage: true,
				firstIcon: "mdi-arrow-collapse-left",
				lastIcon: "mdi-arrow-collapse-right",
			},
			tableOptions: {
				page: 1,
				offset: +this.$route.query.offset ? +this.$route.query.offset : 0,
				itemsPerPage: +this.$route.query.limit ? +this.$route.query.limit : 10,
				// sortBy: [],
				// sortDesc: [],
			},
			noDataText: "There is No Result.",
		};
	},
	mounted() {
		// Get query params for the URL
		this.currentIns = +this.$route.query.ins
			? +this.$route.query.ins
			: this.getInstituteId;
		// Call institutes in case of super admin
		if (this.userObj.auth.user.user.user_type === "operator")
			this.getAllInstitutes();
	},
	methods: {
		/**
		 * Get all Institutes from the API
		 */
		getAllInstitutes() {
			this.axios(`${process.env.VUE_APP_APIEndPoint}institutes/`, this.headers)
				.then(
					res =>
						(this.institutes = res.data.data.sort((a, b) =>
							a?.name.toLowerCase() > b?.name.toLowerCase() ? 1 : -1
						))
				)
				.catch(err => console.error(err));
		},

		/**
		 * Change Institute
		 */
		changeInstitute() {
			if (!this.currentIns) this.currentIns = 1;
			history.pushState(
				{},
				null,
				`${this.$route.path}?ins=${this.currentIns}&offset=${this.tableOptions.offset}&limit=${this.tableOptions.itemsPerPage}`
			);

			this.clearSearch();
		},

		async getContactUsList(offset = 0, limit, search) {
			const body = { institute: this.currentIns, offset, limit, ...search };

			await this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}auth/contact_us/list/`,
					body,
					this.headers
				)
				.then(res => {
					this.contactList = res.data.contacts;
					this.totalContacts = res.data.pagination_data.count;
				})
				.catch(err => this.formatErrors(err));
		},

		async searchForContact() {
			this.search = {};

			if (this.searchObj.fullName) {
				this.search.full_name = this.searchObj.fullName;
			}

			if (this.searchObj.email) {
				this.search.email = this.searchObj.email;
			}

			// if (this.searchObj.phoneNumber) {
			// 	this.search.phone_number = this.searchObj.phoneNumber;
			// }

			await this.getContactUsList(
				this.tableOptions.offset,
				this.tableOptions.itemsPerPage,
				this.search
			);
		},

		async updateContactUsList(options) {
			this.tableOptions.offset = options.itemsPerPage * (options.page - 1);
			this.tableOptions.itemsPerPage = options.itemsPerPage;
			this.tableOptions.page = this.tableOptions.offset
				? this.tableOptions.offset / this.tableOptions.itemsPerPage + 1
				: 1;
			// Change URL without reloading the page
			history.pushState(
				{},
				null,
				`${this.$route.path}?ins=${this.currentIns}&offset=${this.tableOptions.offset}&limit=${this.tableOptions.itemsPerPage}`
			);

			this.getContactUsList(
				this.tableOptions.offset,
				this.tableOptions.itemsPerPage,
				this.search
			);
		},

		clearSearch() {
			this.tableOptions.offset = 0;
			this.tableOptions.itemsPerPage = 10;
			this.tableOptions.page = 1;
			this.searchObj = {};
			this.search = {};
			this.getContactUsList(
				this.tableOptions.offset,
				this.tableOptions.itemsPerPage,
				{}
			);
		},
	},
	computed: {
		/**
		 * Check if user is super admin or not
		 */
		checkUser() {
			return this.userObj.auth.user.user.user_type === "operator";
		},

		/**
		 * Gets current chosen institute ID
		 */
		getInstituteId() {
			return this.userObj.auth.user.user.user_type === "operator"
				? 1
				: +this.userObj.auth.user.user.username.slice("").at(-1);
		},

		contactListHeaders() {
			return [
				{ text: this.$t("tables.id"), value: "id", sortable: false },
				{ text: this.$t("tables.name"), value: "full_name", sortable: false },
				{ text: this.$t("tables.email"), value: "email", sortable: false },
				{
					text: this.$t("tables.phoneNumber"),
					value: "phone_number",
					sortable: false,
				},
				{
					text: this.$t("tables.createDateAndTime"),
					value: "created_at",
					sortable: false,
				},
				{
					text: this.$t("tables.updateDateAndTime"),
					value: "updated_at",
					sortable: false,
				},
			];
		},
	},
};
</script>

<style lang="scss" scoped>
.search {
	display: grid;
	grid-template-columns: 1fr;
	align-items: center;

	.search-inputs {
		display: grid;
		grid-template-columns: 1fr;
		margin-top: 1rem;
		align-items: center;
	}

	.search-btn-group {
		display: flex;
		justify-content: center;
		margin-bottom: 2rem;
	}
}

@media (min-width: 767px) {
	.search {
		.search-inputs {
			grid-template-columns: 1fr 1fr;
			gap: 1rem;
		}

		.search-btn-group {
			margin-bottom: 0;
		}
	}
}
</style>
